import React from 'react';
import { TeamMembersData } from 'Data';

// This is the team members section under the About Us page
const TeamMembers = () => {
	return (
		<>
			{TeamMembersData.map((member, id) => (
				<div key={id} className='flex flex-col items-center'>
					<div className='w-60 h-60 rounded-full overflow-hidden border-4 border-secondary border-solid'>
						<img
							src={member.image}
							alt={member.name}
							className='w-full h-full object-cover'
						/>
					</div>
					<div className='text-lg pt-6 text-center'>
						<p className='font-bold'>{member.name}</p>
						<p className='font-normal'>{member.title}</p>
					</div>
				</div>
			))}
		</>
	);
};

export default TeamMembers;
